/**
 * 事件发射器 Hook
 * 提供事件监听、触发等功能
 */

(function (window) {
  class Emitter {
    constructor() {
      this.listeners = Object.create(null);
    }

    // 监听事件
    on(event, callback) {
      if (!this.listeners[event]) {
        this.listeners[event] = [];
      }
      this.listeners[event].push(callback);
      return this; // 支持链式调用
    }

    // 移除事件监听
    off(event, callback) {
      if (!this.listeners[event]) return this;

      if (callback) {
        this.listeners[event] = this.listeners[event].filter((listener) => listener !== callback);
      } else {
        delete this.listeners[event];
      }
      return this;
    }

    // 触发事件
    emit(event, ...args) {
      const listeners = (this.listeners[event] || []).slice();
      for (const listener of listeners) {
        listener.apply(this, args);
      }
      return this;
    }

    // 单次监听
    once(event, callback) {
      const wrapper = (...args) => {
        callback.apply(this, args);
        this.off(event, wrapper);
      };
      return this.on(event, wrapper);
    }
  }

  window.useEmitter = function () {
    return new Emitter();
  };
})(window);
